export const REDEEMING = 'isRedeeming' as const;
export const PAYMENT_PROVIDER = 'paymentProvider' as const;
export const AUTH_LANDING_PAGE_LOGIN = 'LOGIN' as const;
export const AUTH_LANDING_PAGE_REGISTER = 'SIGNUP' as const;

export const RedemptionStatus = Object.freeze({
  SUBMITTED_ANONYMOUS: 'SUBMITTED_ANONYMOUS',
  WAITING: 'WAITING',
  SUBMITTED: 'SUBMITTED',
  ACQUIRING_PRODUCT: 'ACQUIRING_PRODUCT',
} as const);

export const Actions = Object.freeze({
  ENTER_CODE_REDEMPTION_FLOW: 'ENTER_CODE_REDEMPTION_FLOW',
  RESET_SPECIAL_OFFER: 'RESET_SPECIAL_OFFER',
  UPDATE_REDEMPTION_STATE: 'UPDATE_REDEMPTION_STATE',
} as const);

export const ErrorCodes = Object.freeze({
  ACQUIRE_PRODUCT_FAILED: 'ACQUIRE_PRODUCT_FAILED',
  ALREADY_SUBSCRIBED: 'ALREADY_SUBSCRIBED',
  FAMILY_PLAN_AGE_INELIGIBLE: 'FAMILY_PLAN_AGE_INELIGIBLE',
  INVALID_CODE: 'INVALID_CODE',
  NO_TRIAL_ELIGIBILITY: 'NO_TRIAL_ELIGIBILITY',
  UNEXPECTED_ERROR: 'UNEXPECTED_ERROR',
} as const);

export const OfferTypes = Object.freeze({
  // the redeemCode API uses this form
  CODE_PRODUCT: 'CODE_PRODUCT',
  // the acquireProduct API uses this form
  ACQUIRE_CODE_PRODUCT: 'CodeProduct',
} as const);

export const ProductKeys = Object.freeze({
  TIER: 'tier',
  DISCOUNT_TYPE: 'discountType',
} as const);

export const ReducerKeys = Object.freeze({
  AUTH_CAMPAIGN_COPY: 'AUTH_CAMPAIGN_COPY',
  AUTH_LANDING_PAGE: 'authLandingPage',
  CAMPAIGN_COPY: 'campaignCopy',
  DELAYED_ACTIVATION: 'delayedActivation',
  FTUX_CAMPAIGN_COPY: 'FTUX_CAMPAIGN_COPY',
  PAYMENT_CAMPAIGN_COPY: 'PAYMENT_CAMPAIGN_COPY',
  SPECIAL_OFFER_CAMPAIGN_ID: 'campaignId',
  SPECIAL_OFFER_CODE: 'specialOfferCode',
  SPECIAL_OFFER_ERROR_MESSAGE: 'specialOfferErrorMessage',
  SPECIAL_OFFER_PRODUCTS: 'specialOfferProducts',
  SPECIAL_OFFER_STATUS: 'specialOfferStatus',
} as const);

export const SpecialOfferStatsActions = Object.freeze({
  OFFER_REDEEM_FAILED: 'offer_redeem_failed',
  OFFER_REDEEM_SUCCESS: 'offer_redeem_success',
} as const);

// TODO: WEBCLIENT-7848 This messaging should come from the API directly for CODE_INVALID
export const Messages = Object.freeze({
  alreadyRedeemed: {
    id: 'alreadyRedeemed',
    defaultMessage: 'Sorry, this code has already been redeemed.',
  },
  blackhawkNumberAsRedeemCode: {
    id: 't.blackhawkNumberAsRedeemCode',
    defaultMessage:
      '1. To redeem your Pandora gift card go to {upgradeLink}.{newLine}' +
      '2. Select your desired plan.{newLine}' +
      '3. Enter your Pandora gift card in the credit card form along with your name and postal code.',
  },
  blackhawkNumberAsRedeemCodeDirectBilled: {
    id: 't.blackhawkNumberAsRedeemCodeDirectBilled',
    defaultMessage:
      '1. To redeem your Pandora gift card go to {subsLink}.{newLine}' +
      '2. Select "Update" in the payment info module.{newLine}' +
      '3. Enter your Pandora gift card in the credit card form along with your name and postal code.',
  },
  codeRequired: {
    id: 'codeRequired',
    defaultMessage: 'Please enter a code to redeem',
  },
  congratulationsDuration: {
    id: 'congratulationsHeader',
    defaultMessage: 'With {displayableDuration} free.',
  },
  congratulationsDurationDelayed: {
    id: 'congratulationsDurationDelayed',
    defaultMessage:
      'Looks like you already have a subscription to {activeProductPlanName}. Once you cancel that, your {displayableDuration} of {specialOfferProductPlanName} will go into effect.',
  },
  congratulationsTermsAndConditions: {
    id: 'congratulationsTermsAndConditions',
    defaultMessage:
      'Offer redemption and your subscription are subject to the {termsLink}. \n Additional terms may apply, please see {trialOffersLink} for details.',
  },
  existingPremiumPlanInlineError: {
    id: 'existingPremiumPlanInlineError',
    defaultMessage:
      "Sorry, you aren't eligible to redeem this code because you already have Pandora Premium.",
  },
  giftCardErrorLinkTitle: {
    id: 'giftCardErrorLinkTitle',
    defaultMessage: 'Pandora Gift Card Redemption',
  },
  ineligible: {
    id: 'ineligible',
    defaultMessage: 'Sorry, you aren’t eligible to redeem this code.',
  },
  invalidCode: {
    id: 'invalidCode',
    defaultMessage: 'The code you entered does not appear to be valid.',
  },
  isVendorBilled: {
    id: 'isVendorBilled',
    defaultMessage:
      'Your gift subscription has been applied to your account, but will only be effective when you cancel your {pandoraTier} subscription via the vendor you signed up with.',
  },
  startListening: {
    id: 't.startListening',
    defaultMessage: 'Start Listening',
  },
  subscriptionNowActive: {
    id: 'subscriptionNowActive',
    defaultMessage:
      'Congratulations, your {durationUnits}-{durationType} {pandoraTier} subscription is now active.',
  },
  tooManyAttempts: {
    id: 'tooManyAttempts',
    defaultMessage:
      'Sorry, you’ve reached the maximum number of attempts to redeem a code for today.',
  },
  unableToAcquireProduct: {
    id: 'unableToAcquireProduct',
    defaultMessage:
      'Something went wrong. Try redeeming your code again and if the problem continues, please come back and try again later.',
  },
  unexpectedError: {
    id: 'unexpected error',
    defaultMessage: 'Sorry, something has gone wrong.',
  },
} as const);

export const TextFields = Object.freeze({
  agreeToTerms: {
    id: 'agreeToTerms',
    defaultMessage: 'I have read and agree to the',
  },
  appliedToEmail: {
    id: 'appliedToEmailId',
    defaultMessage: 'This code will be applied to {email}',
  },
  contactSupport: {
    id: 'contactSupport',
    defaultMessage: 'Contact Support',
  },
  issueRedeeming: {
    id: 'issueRedeeming',
    defaultMessage: 'Problems redeeming a code?',
  },
  newWindowLink: {
    id: 'newWindowLink',
    defaultMessage: 'Opens new window',
  },
  notCorrectEmail: {
    id: 'notCorrectEmail',
    defaultMessage: 'Not you?',
  },
  redeemButton: {
    id: 'redeemButton',
    defaultMessage: 'Redeem',
  },
  redeemCode: {
    id: 'redeemCode',
    defaultMessage: 'Redeem Your Code',
  },
  redeemInputText: {
    id: 'redeemInputText',
    defaultMessage: 'Enter gift card or promo code',
  },
  termsLink: {
    id: 'termsLink',
    defaultMessage: 'Pandora Subscription Terms',
  },
} as const);

export const RedeemedOfferTypes = Object.freeze({
  GIFT: 'gift',
  GIFT_DELAYED: 'giftDelayed',
  PROMO: 'promo',
} as const);

export const CongratulationsHeaders = Object.freeze({
  [RedeemedOfferTypes.GIFT]: {
    id: RedeemedOfferTypes.GIFT,
    defaultMessage: 'Congrats! You’re now a {tier} listener.',
  },
  [RedeemedOfferTypes.GIFT_DELAYED]: {
    id: RedeemedOfferTypes.GIFT_DELAYED,
    defaultMessage: 'Congrats! Just one more thing...',
  },
  [RedeemedOfferTypes.PROMO]: {
    id: RedeemedOfferTypes.PROMO,
    defaultMessage: 'Congrats! You’re now a {tier} subscriber.',
  },
} as const);
